"use client";
import { type ReactNode, useState } from "react";
import clsx from "clsx";
import { ChevronUp } from "@/components/newIcons/ChevronUp";

type Props = {
  description: ReactNode;
  showMoreNode: ReactNode;
  showMoreText: string;
};
export const Introduction = ({ description, showMoreNode, showMoreText }: Props) => {
  const [showMore, setShowMore] = useState(false);

  return (
    <>
      <div
        className={clsx("prose", {
          "line-clamp-4": !showMore,
        })}
      >
        {description}
        {showMore && showMoreNode}
      </div>
      {!(showMoreText === "<p></p>" || showMoreText === "") && (
        <div
          className="text-base flex items-center cursor-pointer underline justify-end"
          onClick={() => setShowMore(!showMore)}
        >
          {showMore ? "Voir moins" : "Lire la suite"}
          <ChevronUp
            className={clsx("ml-[5px]", {
              "rotate-180": !showMore,
            })}
          />
        </div>
      )}
    </>
  );
};
